/**
 * POVLAČENJE ZA OSVJEŽAVANJE (krug 10, nalaz 4).
 *
 * Ljuska je od Z15 visoka točno jedan zaslon i dokument se ne pomiče
 * (`useLjuskaBezPomaka`, `overscroll-behavior-y: contain`) — a to je isto ono što
 * je ubilo **nativno** povlačenje za osvježavanje. Nije greška: bez sidrenja se
 * cijela aplikacija odmicala od ruba i iza nje je bljeskala podloga. Ali je
 * ostavilo rupu, jer je gesta u instaliranoj PWA jedini način da korisnik kaže
 * "provjeri ponovno": adresne trake nema, pa nema ni gumba za osvježavanje.
 *
 * Zato vlastito. Ovdje je RAČUN, bez ijedne komponente i bez DOM-a, pa se da
 * izmjeriti: koliki je pomak nakon otpora, je li prijeđen prag i smije li se
 * gesta uopće početi. Sve što je vidljivo (zlatni indikator) i sve što se pri
 * puštanju dogodi (dohvat + provjera novog izdanja) stoji u `Osvjezavanje.tsx`.
 */

/** Koliko se prstom mora povući da se osvježavanje okine. */
export const PRAG_PX = 64

/** Dalje od ovoga indikator ne ide — guma je do kraja rastegnuta. */
export const NAJVISE_PX = 96

/**
 * Prst povuče više nego što se sadržaj pomakne, i to sve manje kako ide dalje:
 * gesta tako ima "težinu" i ne okine se na svako listanje koje je slučajno
 * počelo na vrhu. Korijen umjesto linearnog množitelja jer prvih nekoliko
 * piksela mora biti odziv (inače izgleda da se ekran zaglavio), a zadnjih
 * nekoliko otpor (inače se okine bez namjere).
 */
export function pomakPovlacenja(prijedeno: number): number {
  if (prijedeno <= 0) return 0

  const otporan = Math.sqrt(prijedeno) * 7

  return Math.min(otporan, NAJVISE_PX)
}

/** Je li povučeno dovoljno da se pri puštanju osvježava. */
export function dosegnutPrag(pomak: number): boolean {
  return pomak >= PRAG_PX
}

/**
 * Smije li gesta početi.
 *
 * Uvjet je da je platno NA VRHU: povlačenje usred popisa je listanje, a ne
 * zahtjev za osvježavanjem. `scrollTop` zna biti i mali negativan broj (elastika
 * na iOS-u), pa granica nije stroga nula.
 */
export function naVrhu(scrollTop: number): boolean {
  return scrollTop <= 1
}

/**
 * Koliko je indikator "pun" (0–1) — iz toga se crta i prozirnost i zakret.
 * Iznad praga ostaje 1: indikator koji raste i nakon što je posao osiguran ne
 * govori ništa novo.
 */
export function napunjenost(pomak: number): number {
  return Math.max(0, Math.min(1, pomak / PRAG_PX))
}
